import Document from "../components/Document";

export default function RefundPage() {
    const refundUrl = 'https://drive.google.com/file/d/1uBRJjUm-o31lp3teNh4F7HpXNF3wEP-j/preview';
    return (
        <Document url={refundUrl} title='Refund' />
    )
}